<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission" v-if="!notFound">
      <div class="mission-content">
        <div class="luckyDraw-list">
          <div class="mission-t mt20">
            {{$t('drawPrize')}}
          </div>

          <div class="prize-c flex">
            <div class="prize-one">
              <div class="name">{{$t('GrandPrize')}}</div>
              <div class="img">
                <img src="../../static/images/prize-img.png" />
              </div>
              <div class="prize-name">
                <strong class="">"{{$t('FirstPrize')}}"</strong>
              </div>
            </div>
            <div class="prize-two">
              <div class="name">{{$t('GrandPrize')}}</div>
              <div class="img">
                <img style="width: auto;" src="../../static/images/prize-img1.png" />
              </div>
              <div class="prize-name">
                <strong>"{{$t('SecondPrize')}}"</strong>
              </div>
            </div>
          </div>
         <!-- <div class="mt30 ac">
            <button class="btn btn-none">{{$t('drawPrize')}}</button>
          </div> -->
          <div class="ac mt50" style="color:#0c0c0c;font-size:34px;">{{$t('drawfont')}}</div>
        </div>

        <div class="point-history lucky-li mt20" v-if="list.length>0">
          <div class="point-t ac disflex">
            <span class="point-one1">{{$t('Name')}}</span>
            <span class="point-one2">{{$t('Prize')}}</span>
          </div>
          <div class="point-c">
            <div class="point-li ac disflex" v-for="(item,index) in list">
              <span class="point-one1">{{item.nickname}}</span>
              <span class="point-one2">{{item.remark}}</span>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page_id:1,
			page_size:10,
			isShow:'All',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      back(){
        this.$router.push({path:'/index'})
      },
      getHome(){
        let that =this;
       // / that.$parent.loadModal(true);
        that.$api.get('/api/lucky/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if(r.data.length>0){
              that.list = r.data
            }else{
              that.isShow = false;
          }
        });
      })
    },
    getList(item){
      this.isShow = item
    },
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getHome();
			}else{
				//that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/luckyDraw.vue